import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const markets = [
    {
      name: 'Dominican Republic',
      status: 'Active',
      flag: '🇩🇴',
      stats: { vendors: '5,200+', bookings: '320K' },
    },
    {
      name: 'New York',
      status: 'Active',
      flag: '🇺🇸',
      stats: { vendors: '3,100+', bookings: '180K' },
    },
    {
      name: 'Puerto Rico',
      status: 'Active',
      flag: '🇵🇷',
      stats: { vendors: '2,400+', bookings: '210K' },
    },
    {
      name: 'Miami',
      status: 'Active',
      flag: '🇺🇸',
      stats: { vendors: '1,700+', bookings: '137K' },
    },
  ];

  const upcomingMarkets = [
    { name: 'Colombia', flag: '🇨🇴' },
    { name: 'Brazil', flag: '🇧🇷' },
    { name: 'Chile', flag: '🇨🇱' },
    { name: 'Mexico', flag: '🇲🇽' },
  ];

  const compliance = [
    { name: 'SOC 2 Type II', status: 'In Progress' },
    { name: 'PCI DSS', status: 'Compliant' },
    { name: 'GDPR Ready', status: 'Compliant' },
    { name: 'KYC/KYB', status: 'Implemented' },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-wide mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-sm font-medium text-accent uppercase tracking-wider mb-3">
            Market Presence
          </p>
          <h2 className="text-display text-foreground mb-6">
            Growing Across the Americas
          </h2>
          <p className="text-body-large">
            Establishing the leading marketplace infrastructure for local services,
            one market at a time.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {/* Active Markets */}
          <div className="lg:col-span-2">
            <h3 className="text-lg font-semibold text-foreground mb-6">
              Active Markets
            </h3>
            <div className="grid sm:grid-cols-2 gap-4">
              {markets.map((market, index) => (
                <div
                  key={index}
                  className="p-5 bg-muted rounded-brand border border-transparent hover:border-border hover:bg-white transition-all duration-300"
                >
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-3">
                      <span className="text-2xl">{market.flag}</span>
                      <div>
                        <div className="font-medium text-foreground">{market.name}</div>
                        <div className="flex items-center gap-1.5 text-xs text-accent">
                          <span className="w-1.5 h-1.5 bg-accent rounded-full"></span>
                          {market.status}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 pt-4 border-t border-border">
                    <div>
                      <div className="text-lg font-semibold text-foreground">{market.stats.vendors}</div>
                      <div className="text-xs text-muted-foreground">Vendors</div>
                    </div>
                    <div>
                      <div className="text-lg font-semibold text-foreground">{market.stats.bookings}</div>
                      <div className="text-xs text-muted-foreground">Bookings</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Upcoming Markets */}
            <div className="mt-8">
              <h4 className="text-sm font-medium text-muted-foreground mb-4">
                Expansion Roadmap
              </h4>
              <div className="flex flex-wrap gap-3">
                {upcomingMarkets.map((market, index) => (
                  <div
                    key={index}
                    className="inline-flex items-center gap-2 px-4 py-2 bg-muted rounded-full text-sm"
                  >
                    <span>{market.flag}</span>
                    <span className="text-muted-foreground">{market.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Trust & Compliance */}
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-6">
              Trust & Compliance
            </h3>
            <div className="bg-muted rounded-brand p-6">
              <div className="space-y-4">
                {compliance.map((item, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-between py-3 border-b border-border last:border-0"
                  >
                    <span className="text-sm text-foreground">{item.name}</span>
                    <span className={`text-xs font-medium px-2.5 py-1 rounded-full ${
                      item.status === 'Compliant' || item.status === 'Implemented'
                        ? 'bg-accent/10 text-accent'
                        : 'bg-secondary/10 text-secondary'
                    }`}>
                      {item.status}
                    </span>
                  </div>
                ))}
              </div>

              <a
                href="/compliance"
                className="flex items-center justify-center gap-2 mt-6 px-4 py-2.5 bg-white text-foreground text-sm font-medium rounded-brand-sm border border-border hover:bg-muted transition-colors"
              >
                View Compliance Details
                <Icon name="ArrowRight" size={14} />
              </a>
            </div>

            {/* Corporate Structure */}
            <div className="mt-6 p-6 bg-primary rounded-brand text-white">
              <h4 className="font-semibold mb-3">Corporate Structure</h4>
              <p className="text-sm text-white/70 mb-4">
                Delaware C-Corp with local subsidiaries for regulatory compliance.
              </p>
              <a
                href="/corporate-structure"
                className="inline-flex items-center text-sm font-medium text-white hover:text-white/80 transition-colors"
              >
                Learn more
                <Icon name="ArrowRight" size={14} className="ml-2" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSignals;
